import Img from 'gatsby-image';
import styled from 'styled-components';

import UI from '#front-credpago';

import globals from '../../globals';

const { containerMaxWidth } = globals;

export const Wrapper = styled.div`
  background: #f1f1f1;
  height: 654px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    height: auto;
  }

  @media ${UI.globals.mediaqueries.md} {
    height: 790px;
  }

  @media ${UI.globals.mediaqueries.lg} {
    height: 685px;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    height: 692px;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: calc(${containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;

  h2 {
    display: flex;
    flex-direction: column;
  }
`;
export const WrapperImg = styled.div`
  position: relative;
`;

export const ImgCouple = styled(Img)`
  position: absolute;
  bottom: 80px;
  width: 100%;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    bottom: 0px;
    top: 20px;
  }

  @media ${UI.globals.mediaqueries.md} {
    top: 278px;
    width: 140%;
    right: 90px;
  }

  @media ${UI.globals.mediaqueries.lg} {
    top: 67px;
    width: 90%;
    right: -70px;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    top: 86px;
    width: 120%;
    right: 63px;
  }
`;

export const WrapperDescription = styled.div`
  margin-top: 30px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin: 20px;
  }
`;

export const ColumnImg = styled(UI.Col)`
  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    padding: 0px 80px;
  }
`;
